<template>
    <div class="reply_box_preview">
        <div class="row align-items-center">
            <div class="col-11">
                <div v-if="replyMessageData" class="reply_usr_info">
                    <div class="reply_msg_send_status">
                        <div class="reply_msg_un">
                            <span class="message_sender_name">
                                {{ senderName }}
                            </span>
                        </div>

                        <div class="reply_msg_txt">
                            <safe-message-content v-if="messageText" :message="messageText" />

                            <span v-else-if="fileUrl" class="reply_msg_file_wrp">
                                <a :href="safeFileUrl" target="_blank" rel="noopener noreferrer">
                                    {{ fileName }}
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-1 pl-0 ml-auto">
                <span class="reply_box_close" role="button" tabindex="0" aria-label="Cancel reply"
                    @click="$emit('cancel')" @keydown.enter.prevent="$emit('cancel')"
                    @keydown.space.prevent="$emit('cancel')">
                    <img src="@/assets/images/close.png" class="img-fluid" alt="">
                </span>
            </div>
        </div>
    </div>
</template>

<script>
function normalizeStoredMessage(value) {
    return String(value || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/?span(?:\s[^>]*)?>/gi, '')
        .replace(/<[^>]+>/g, '');
}

function appendTextNodes(createElement, children, value) {
    String(value).split('\n').forEach((line, index) => {
        if (index > 0) {
            children.push(createElement('br'));
        }

        if (line) {
            children.push(line);
        }
    });
}

const SafeMessageContent = {
    name: 'SafeMessageContent',
    functional: true,
    props: {
        message: {
            type: String,
            default: ''
        }
    },
    render(createElement, context) {
        const message = normalizeStoredMessage(context.props.message);
        const tokenPattern = /(https?:\/\/[^\s]+|\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b|@[a-zA-Z0-9._-]+)/gi;
        const children = [];
        let cursor = 0;
        let match = tokenPattern.exec(message);

        while (match) {
            appendTextNodes(
                createElement,
                children,
                message.slice(cursor, match.index)
            );

            const token = match[0];

            if (/^https?:\/\//i.test(token)) {
                children.push(createElement('a', {
                    class: 'hyper_link',
                    attrs: {
                        href: token,
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }, token));
            } else if (token.charAt(0) === '@') {
                children.push(createElement('span', { class: 'mention' }, token));
            } else {
                children.push(createElement('a', {
                    class: 'hyper_link',
                    attrs: {
                        href: `mailto:${token}`
                    }
                }, token));
            }

            cursor = match.index + token.length;
            match = tokenPattern.exec(message);
        }

        appendTextNodes(createElement, children, message.slice(cursor));

        return createElement(
            'span',
            { class: 'chat_msg_content_show' },
            children
        );
    }
};

export default {
    name: 'ChatReplyPreview',

    components: {
        'safe-message-content': SafeMessageContent
    },

    props: {
        replyMessageData: {
            type: Object,
            default: null
        }
    },

    computed: {
        replySource() {
            if (!this.replyMessageData) {
                return null;
            }

            if (
                this.replyMessageData.forwarded &&
                this.replyMessageData.forwarded_from
            ) {
                return this.replyMessageData.forwarded_from;
            }

            return this.replyMessageData;
        },

        senderName() {
            const sender = this.replyMessageData && this.replyMessageData.sender;

            if (!sender) {
                return '';
            }

            return [sender.first_name, sender.last_name]
                .filter(Boolean)
                .join(' ');
        },

        messageText() {
            return this.replySource && this.replySource.message
                ? String(this.replySource.message)
                : '';
        },

        fileUrl() {
            return this.replySource && this.replySource.file
                ? this.replySource.file
                : '';
        },

        safeFileUrl() {
            if (!this.fileUrl) {
                return '#';
            }

            const anchor = document.createElement('a');
            anchor.href = this.fileUrl;

            return anchor.protocol === 'http:' || anchor.protocol === 'https:'
                ? this.fileUrl
                : '#';
        },

        fileName() {
            const cleanFile = String(this.fileUrl || '').split(/[?#]/)[0];
            const filename = cleanFile.split('/').pop() || '';

            try {
                return decodeURIComponent(filename);
            } catch (error) {
                return filename;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.reply_box_preview {
    padding: 5px 20px 0;
    background: none;

    .reply_usr_info {
        padding: 5px 10px;
        background: #232323;
        border-left: 3px solid #87cefa;
        border-radius: 5px;

        .message_sender_name {
            color: #87cefa;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 1;
        }
    }

    .reply_box_close {
        .img-fluid {
            max-width: 15px;
            cursor: pointer;

            &:hover {
                filter: invert(24%) sepia(100%) saturate(7466%) hue-rotate(0deg);
            }
        }
    }


    .reply_msg_txt {
        .chat_msg_content_show {
            color: #d2d2d2;
            font-size: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
            max-height: 15px;
            word-wrap: anywhere;
        }

        .reply_msg_file_wrp {
            display: flex;
            align-items: center;
            margin-top: 5px;

            .img-fluid {
                width: 25px;
                margin-right: 5px;
            }
            a{
                color: #fff;
                font-size: 12px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                display: block;
            }
        }
    }
}
</style>
